import { IStore } from '../../../app/store'
import MapRepository from "../gateways/map.repository";
import CourtEntity from "../../../courts/entities/court.entity";

export default class CourtPopupPresenter {
  private readonly store: IStore
  private readonly mapRepo: MapRepository

  constructor (store: IStore) {
    this.store = store

    this.mapRepo = new MapRepository(store)
  }

  popupVisible (): boolean {
    return this.mapRepo.getShowPopup()
  }

  getCourt (): CourtEntity {
    return this.store.map.selectedCourt
  }
}
